<div class="section py-7 section-content">
  <div class="container-xl">
    <div class="row">
      <div class="col-12">
        <h2 class="h3 text-center mb-6">Partners we are proud to work with.</h2>
      </div>
      <div class="col-12">
        <ngu-carousel
          #carousel
          [dataSource]="logos"
          [inputs]="carouselTile"
          class="carousel partners-logos-carousel pb-6"
        >
          <ngu-item *nguCarouselDef="let logo; let i = index" NguCarouselItem class="single-slide">
            <div class="partner-logo d-flex align-items-center justify-content-center">
              <img [src]="logo.path" alt="Partner Logo" class="partner-logo-img img img-fluid" loading="lazy" />
            </div>
          </ngu-item>
          <ul NguCarouselPoint class="list-inline list-unstyled text-center position-absolute carousel-points mb-2">
            <li
              (click)="carousel.moveTo(j)"
              *ngFor="let item of carousel.pointNumbers(); let j = index"
              [class.active]="j === carousel.currentSlide"
              class="list-inline-item carousel-point"
            >
              {{ j }}
            </li>
          </ul>
        </ngu-carousel>
      </div>
    </div>
  </div>
</div>
